/* eslint-disable complexity */
import { isValidDateParts } from '@/domain/termine/shared/utils/dateValidations';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

export function useDefaultDate() {
  const {
    year,
    month,
    day: dayParam,
  } = useParams<{
    year: string;
    month: string;
    day?: string;
  }>();

  const defaultDate = useMemo(() => {
    if (dayParam && year && month) {
      const yearInt = parseInt(year, 10);
      const monthInt = parseInt(month, 10);
      const dayInt = parseInt(dayParam, 10);

      if (isNaN(yearInt) || isNaN(monthInt) || isNaN(dayInt)) {
        return dayjs().toDate();
      }

      const parsedDate = dayjs()
        .year(yearInt)
        .month(monthInt - 1)
        .date(dayInt)
        .startOf('day');

      if (isValidDateParts(parsedDate, yearInt, monthInt, dayInt)) {
        return parsedDate.toDate();
      }
    }
    return dayjs().toDate();
  }, [dayParam, year, month]);

  return defaultDate;
}
